import styled from "styled-components";

export const InlineOptions = styled.div`
  display: inline-flex;
  gap: 16px;
`;
